import { invoiceBillingTone, type InvoiceBillingTone } from '../utility/invoiceBillingTone';
import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';
const colors: Record<string, { background: string; color: string; border: string }> = {
  complete: { background: '#e3f5e8', color: '#216b35', border: '#a6d8b2' },
  delayed: { background: '#ffebeb', color: '#a61b1b', border: '#efb0b0' },
  pending: { background: '#e7f3ff', color: '#15538b', border: '#a5ccee' },
  month: { background: '#e7f3ff', color: '#15538b', border: '#a5ccee' },
  week: { background: '#fff3c4', color: '#775500', border: '#e5cb70' },
  today: { background: '#fff0db', color: '#974b00', border: '#f3c18c' },
  canceled: { background: '#edf0f2', color: '#4d5963', border: '#c9d0d5' },
};
export function InvoiceStatusBadge({ status, count, paymentDate, tone }: { status: string; count?: number; paymentDate?: string; tone?: InvoiceBillingTone }) {
  const { t } = useTranslation();
  const palette = colors[tone || (paymentDate ? invoiceBillingTone({issue_date:paymentDate,invoice_status:status}) : status)] || colors.pending;
  return <Badge size="sm" style={{ backgroundColor: palette.background, color: palette.color, border: `1px solid ${palette.border}`, fontWeight: 700 }}>
    {t(`invoices.statusOptions.${status}`)}{count !== undefined ? ` · ${count}` : ''}
  </Badge>;
}
